import React, { Component } from 'react';
import { Route } from 'react-router';

import * as Colyseus from "@colyseus/sdk";
//import Lottie from 'react-lottie';
import nosleep from 'nosleep.js';
import "animate.css";

import Loading from "components/Shared/Loading/Loading";

import styles from 'components/Client/ClientStyles.module.scss';
import ClientMenuIcon from 'components/Client/MenuIcons/ClientMenuIcon';

import { GAME_STATES, GAME_ID, MESSAGES, IMAGES } from "constants/constants";
import { isTerminalByCode, retryDelayForCode, isTerminalReconnectError } from "services/connectionManager";
import Player from '../Shared/Player/Player';

import ClientPodium from "images/Client/client-podium.png";
import ClientPodiumGlow from "images/Client/client-podium-glow.png";
import categoryCapsule from "images/Host/High res_Question_Container.png";
import sendIcon from "images/Client/paper-plane-solid-full.svg";

var noSleep = new nosleep();
//var supportsVibrate = "vibrate" in navigator;

export class Client extends Component {
    static displayName = Client.name;

    constructor(props) {
        super(props);

        this.client = new Colyseus.Client(process.env.REACT_APP_GAME_SERVER_URL);
        this.state = {
            roomId: 0,
            room: null,
            myId: null,
            roomState: null,
            redirect: null,
            redirectURL: "",
            isPaused: false,
            players: [],
            player: null,
            showDefaultView: true,
            doingTutorial: false,
            answer: "",
            connected: false,
            reconnectionToken: null,
        };
        this.locationCheckInterval = null;
        this.reconnectTimer = null;
    }

    componentDidMount() {
        window.addEventListener('offline', this.handleOffline);
        window.addEventListener('online', this.handleOnline);

        // Reconnect immediately — matches OnePercentClub. The 0.17 SDK's own
        // auto-retry is deduped against our explicit reconnect via scheduleReconnect.
        this.doReconnect();

        document.addEventListener('click', function enableNoSleep() {
            document.removeEventListener('click', enableNoSleep, false);
            noSleep.enable();
        }, false);
    }

    componentWillUnmount() {
        window.removeEventListener('offline', this.handleOffline);
        window.removeEventListener('online', this.handleOnline);
        if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
        if (this.locationCheckInterval) clearInterval(this.locationCheckInterval);
    }

    handleOffline = () => {
        if (this.state.room) {
            try {
                this.state.room.reconnection.maxRetries = 0;
                this.state.room.removeAllListeners();
                this.state.room.leave(false);
            } catch { }
        }
        this.setState({ connected: false, room: null });
        this.scheduleReconnect(1000);
    };

    handleOnline = () => {
        this.setState({ connected: false, room: null }, () => {
            this.scheduleReconnect(0);
        });
    };

    getReconnectionToken = () => {
        const fromUrl = this.getQueryStringValue("token");
        if (fromUrl) return fromUrl;
        if (this.state.reconnectionToken) return this.state.reconnectionToken;
        return null;
    };

    scheduleReconnect = (delayMs = 2000) => {
        if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
        this.reconnectTimer = setTimeout(() => this.doReconnect(), delayMs);
    };

    getQueryStringValue(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }

    // checking to ensure player is in the right place e.g. in the correct game
    startLocationChecks() {
        this.state.room.send("location_check", { gameId: GAME_ID });
        this.locationCheckInterval = setInterval(() => {
            this.state.room.send("location_check", { gameId: GAME_ID });
        }, 10000);
    }

    skipTutorial() {
        this.state.room.send("vote_skip");
        this.setState({ doingTutorial: false });
    }

    goToLobby() {
        this.setState({ redirect: true, redirectURL: `${this.getRedirectURL()}/join/?token=${this.state.reconnectionToken}` });
        this.state.room.reconnection.maxRetries = 0;
        this.state.room.leave(false);
        if (this.locationCheckInterval) clearInterval(this.locationCheckInterval);
    }

    getRedirectURL(display = false) {
        let url = display ? process.env.REACT_APP_GAME_CITY_URL_DISPLAY : process.env.REACT_APP_GAME_CITY_URL;
    
        return url;
    }

    checkAndAddPlayer(player) {
        if (!this.state.players.find(elem => elem.id === player.id)) {
            this.setState((prevState) => {
                return { players: [...prevState.players, player] }
            });
        }
    }

    setupStateListeners = (roomState, $) => {
        $(roomState).players.onAdd((player, key) => {
            console.log(player, "has been added at", key);
            this.checkAndAddPlayer(player);

            if (player.id === this.state.myId) {
                const changes = ["connected", "votedSkip", "avatar", "name", "id", "primaryPlayer"];
                changes.forEach(change => {
                    $(player).listen(change, (value) => {
                        let statePlayer = { ...this.state.player };
                        statePlayer[change] = value;

                        this.setState({ player: statePlayer });
                    });
                });

                /* Example player state listers */
                //const ycsuPlayerChanges = ["teamIndex", "isDescriber", "isDinger", "ready", "currentRuleVoteId",];
                //ycsuPlayerChanges.forEach(change => {
                //    $(player).ycsuData.listen(change, (value) => {
                //        let statePlayer = { ...this.state.player };
                //        statePlayer.ycsuData[change] = value;

                //        this.setState({ player: statePlayer });
                //    });
                //});
            }
        });

        $(roomState).host.listen("connected", (value) => {
            console.log("Host connection change : ", value);
            this.setState({ hostConnected: value });
        });

        /* Example game state listeners */
        //const ycsuStateVars = ["gameState", "roundNumber", "newRuleTeamId", "timer", "timerRunning", "teamSelectionType", "describingTeamId", "currentRuleBreaks", "currentValidationNum", "pointsToWin", "dangerZoneStart"];
        //ycsuStateVars.forEach((stateVar) => {
        //    $(roomState).ycsuData.listen(stateVar, (change) => {
        //        let update = {};
        //        update[stateVar] = change;
        //        this.setState(update);
        //    });
        //});
        //const ycsuStateArrayChanges = ["currentCorrectPairIds", "newRuleZones"];
        //ycsuStateArrayChanges.forEach(arrayName => {
        //    let update = {};
        //    update[arrayName] = [];
        //    this.setState(update);
        //    $(roomState).ycsuData[arrayName].onAdd((change, index) => {
        //        console.log(`YCSU Array ${arrayName} Change ${change} at index ${index}`);
        //        let array = [...this.state[arrayName]];
        //        array[index] = change;
        //        let changeUpdate = {};
        //        changeUpdate[arrayName] = array;
        //        this.setState(changeUpdate);
        //    });
        //    $(roomState).ycsuData[arrayName].onRemove((change, index) => {
        //        console.log(`YCSU Array ${arrayName} Removed ${change} at index ${index}`);
        //        let array = [...this.state[arrayName]];
        //        array[index] = null;
        //        let changeUpdate = {};
        //        changeUpdate[arrayName] = array;
        //        this.setState(changeUpdate);
        //    });
        //});
    }

    updateToken(token) {
        var url = new URL(window.location.href);

        try {
            window.history.replaceState(null, null, (url.pathname) + (`?token=${token}`));
        } catch (e) {
            console.warn(e)
        }
    }

    clickSelectTeam = (e, index) => {
        e.preventDefault();

        this.state.room.send(MESSAGES.TO_SERVER.SELECT_TEAM, { teamId: index });
    }

    updateAnswer = (e) => {
        this.setState({ answer: e.target.value });
    }

    submitAnswer = (e) => {
        if (e) e.preventDefault();

        const player = this.state.roomState?.players?.get(this.state.myId);
        const teams = this.state.roomState?.pointlessData?.teams;
        const team = teams && player ? teams[player.pointlessData.teamIndex] : null;

        if (this.state.answer.length === 0) return;

        if (team.memberIds.length > 1 || this.state.roomState?.pointlessData?.gameState === GAME_STATES.FINAL_ROUND_ANSWERING) {
            this.state.room.send(MESSAGES.TO_SERVER.SUBMIT_ANSWER, { answer: this.state.answer });
        } else {
            this.setState({ showConfirmAnswerView: true, confirmAnswer: this.state.answer, })
        }
        this.setState({ answer: "" });
    }

    voteAnswer = (e, answer, index) => {
        e.preventDefault();
        this.state.room.send(MESSAGES.TO_SERVER.VOTE_ANSWER, { answer, answerIndex: index });
    }

    acceptAnswer = (e) => {
        e.preventDefault();
        this.state.room.send(MESSAGES.TO_SERVER.CONFIRM_ANSWER, { answer: this.state.showConfirmAnswerView ? this.state.confirmAnswer : this.state.suggestAnswer });
        this.setState({ showSuggestAnswerView: false, showConfirmAnswerView: false, });
    }

    declineAnswer = (e) => {
        e.preventDefault();
        this.setState({ showSuggestAnswerView: false, showConfirmAnswerView: false, confirmAnswer: "", suggestAnswer: "" });
    }

    signalStartGame = () => {
        this.state.room?.send(MESSAGES.TO_SERVER.START_GAME, {});
    }
    signalChangeGame = () => {
        this.state.room?.send("change_game", {});
    }
    signalNewGame = () => {
        this.state.room?.send(MESSAGES.TO_SERVER.NEW_GAME, {});
    }

    //getDefaultView() {
    //    return <DefaultView room={this.state.room} player={this.state.player} hostConnected={this.state.hostConnected} players={this.state.players} gameState={this.state.gameState} />
    //}

    doReconnect = () => {
        const token = this.getReconnectionToken();
        const offline = typeof navigator !== "undefined" && navigator.onLine === false;

        if (!token) {
            if (!offline) {
                this.setState({ redirect: true, redirectURL: `${this.getRedirectURL()}/` });
            } else {
                this.scheduleReconnect(3000);
            }
            return;
        }

        // Guard against duplicate reconnects racing the SDK's own auto-retry —
        // 0.17 seat reservations are single-use, so a second reconnect with the
        // same token fails with MatchMakeError.
        if (this.state.connected) return;

        // start reconnecting player to game
        this.client.reconnect(token).then(room => {
            if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
            console.log(room.sessionId, "joined", room.name);
            this.setState({ room: room, connected: true, roomId: room.roomId, myId: room.sessionId, reconnectionToken: room.reconnectionToken });
            this.updateToken(room.reconnectionToken);
            room.send("update_player_token", { reconnectionToken: room.reconnectionToken });

            const $ = Colyseus.getStateCallbacks(room);

            room.onStateChange.once((roomState) => {
                console.log("this is the first room state!", roomState);
                const player = roomState.players.get(room.sessionId);
                if (!player) window.location = this.getRedirectURL();

                this.setState({ roomState: roomState, player, isPaused: roomState.isPaused, });
                this.setupStateListeners(roomState, $)
                this.startLocationChecks();
            });

            room.onStateChange((state) => {
                console.log(room.name, "has new state:", state);
                this.setState({ roomState: state, });
            });

            room.onMessage(MESSAGES.TO_CLIENTS.SEND_CONFIRM_ANSWER, (message) => {
                this.setState({ showConfirmAnswerView: true, confirmAnswer: message.answer })
            });

            room.onMessage(MESSAGES.TO_CLIENTS.SEND_SUGGEST_ANSWER, (message) => {
                this.setState({ showSuggestAnswerView: true, suggestAnswer: message.answer })
            });

            room.onMessage("show_tutorial", (message) => {
                console.log("show_tutorial", "received on", room.name, message);
                this.setState({ doingTutorial: true });
            });
            room.onMessage("end_tutorial", (message) => {
                console.log("end_tutorial", "received on", room.name, message);
                this.setState({ doingTutorial: false });
            });
            room.onMessage("toggle_pause", (message) => {
                console.log("toggle_pause", "received on", room.name, message);
                this.setState({ isPaused: message.pause });
            });

            // your game message handlers here

            room.onMessage("game_starting", (message) => {
                console.log("game_starting", "received on", room.name, message);
                if (message.gameId !== GAME_ID) {
                    this.goToLobby();
                }
            });
            room.onMessage("catchup", (message) => {
                console.log("catchup", "received on", room.name, message);
                if (message.data.id === this.state.myId) {
                    this.doCatchup(message.gameState, message.data);
                }
            });
            room.onMessage("host_joined_lobby", (message) => {
                console.log("host_joined_lobby", "received on", room.name, message);
                this.goToLobby();
            });
            room.onMessage("change_game", (message) => {
                console.log("change_game", "received on", room.name, message);
                this.goToLobby();
            });

            room.onError((code, message) => {
                console.log(this.client.id, "couldn't join", room.name);
            });
            room.onLeave((code) => {
                console.log(this.client.id, "left", room.name, code);

                // If we're already on our way to the lobby, don't fight it.
                if (this.state.redirectURL) {
                    setTimeout(() => {
                        this.setState({ redirect: true, });
                    }, 1500);
                    return;
                }

                const nowOffline = typeof navigator !== "undefined" && navigator.onLine === false;

                if (!nowOffline && isTerminalByCode(code)) {
                    // Terminal (e.g. removed by host, wrong game) — go to lobby.
                    this.setState({ connected: false, redirect: true, redirectURL: `${this.getRedirectURL()}/` });
                    if (this.locationCheckInterval) clearInterval(this.locationCheckInterval);
                } else {
                    // Transient drop — schedule a single, deduped reconnect with
                    // backoff instead of racing the SDK's auto-retry.
                    this.setState({ connected: false });
                    this.scheduleReconnect(retryDelayForCode(code));
                }
            });
        }).catch(e => {
            console.log("JOIN/RECONNECT ERROR", e);
            const nowOffline = typeof navigator !== "undefined" && navigator.onLine === false;

            if (!nowOffline && isTerminalReconnectError(e)) {
                this.setState({ connected: false, redirect: true, redirectURL: `${this.getRedirectURL()}/` });
                if (this.locationCheckInterval) clearInterval(this.locationCheckInterval);
                return;
            }
            this.setState({ connected: false });
            this.scheduleReconnect(2000);
        });

    }


    renderTextDiv(text, additionalStyles) {
        return <>
            <div className={`${styles.text} ${additionalStyles}`}>{text}
                <div className={styles.face}>{text} </div>
            </div>
        </>
    }

    renderMainButton(text, alt = false, disabled = false, callback = null, additionalStyles) {
        return (
            <button className={`${styles.mainButton} ${alt && styles.alt} ${additionalStyles}`} onClick={callback} tabIndex='-1' disabled={disabled}>
                <img src={categoryCapsule} alt="btn-bg" />
                <div className={styles.textBox}>
                    {this.renderTextDiv(text)}
                </div>
            </button>
        )
    }

    getTeamPodium(id) {
        switch (id) {
            case 0:
                return IMAGES.HOST.podium1;
            case 1:
                return IMAGES.HOST.podium2;
            case 2:
                return IMAGES.HOST.podium3;
            case 3:
                return IMAGES.HOST.podium4;
            default:
                return IMAGES.HOST.podiumBlank;
        }
    }

    getTextSizeStyle(text = "", largeBracket = 10, mediumBracket = 25) {
        return text.length <= largeBracket ? styles.large : text.length <= mediumBracket ? styles.medium : styles.small;
    }

    renderPlayerSection(viewState, player, team) {
        //const centerPlayer = [GAME_STATES.LOADING, GAME_STATES., GAME_STATES.GameSelect].includes(viewState);
        const centerPlayer = false;
        return (
            <div className={`${styles.playerSection} ${centerPlayer && styles.center}`}>
                {
                    player && player.id &&
                    <Player player={player} room={this.state.room} team={team} large={centerPlayer} />
                }
                {/*{*/}
                {/*    team && team.name &&*/}
                {/*    <div className={styles.podium}>{this.renderTextDiv(team.name)}</div>*/}
                {/*}*/}
                <div className={styles.podiumName}>
                    <img src={this.getTeamPodium(team?.id)} />
                    <div className={styles.names}>
                        {this.renderTextDiv(`${player.name}`)}
                    </div>
                </div>
            </div>
        )
    }

    renderDefaultView(viewState, player, players, team, teams) {
        const gameState = this.state.roomState?.pointlessData?.gameState;
        const activeTeamIndex = this.state.roomState?.pointlessData?.activeTeamIndex;
        const activeTeam = teams[activeTeamIndex];

        let content = [];
        let showDefaultView = false;

        if (this.state.hostConnected) {
            switch (gameState) {
                case GAME_STATES.ANSWERING:
                    if (activeTeamIndex !== team.id && !this.state.roomState?.pointlessData?.answerTesting) {
                        showDefaultView = true;
                        const explanation = this.state.roomState?.pointlessData?.questionExplanation;
                        if (explanation && explanation.length > 0) {
                            content.push(<div className={styles.explanation}>
                                {this.renderTextDiv(explanation, this.getTextSizeStyle(explanation, 50, 90))}
                            </div>)
                        }
                        const members = players.filter(x => activeTeam.memberIds.includes(x.id));
                        content.push(this.renderTextDiv(`${activeTeam.name} is answering`, styles.title));
                        let nameText = "(";
                        members.forEach((x, i) => {
                            nameText += x.name;
                            if (i === 0 && members.length > 1) nameText += " & ";
                        });
                        nameText += ")"
                        content.push(this.renderTextDiv(nameText));
                    }
                    break;
                case GAME_STATES.REVEAL_ANSWER:
                case GAME_STATES.FINAL_ROUND_REVEAL:
                    if (activeTeam) {
                        showDefaultView = true;
                        const hasAnswer = activeTeam?.answer?.trim().length > 0;
                        if (!hasAnswer) {
                            if (activeTeamIndex === team?.id) {
                                content.push(this.renderTextDiv(`You didn't submit anything`, styles.title));
                            } else {
                                content.push(this.renderTextDiv(`${activeTeam?.name} didn't submit anything`, styles.title));
                            }
                        } else {
                            if (activeTeamIndex === team?.id) {
                                content.push(this.renderTextDiv(`You submitted`, styles.title));
                            } else {
                                content.push(this.renderTextDiv(`${activeTeam?.name} submitted`, styles.title));
                            }
                            content.push(<div className={styles.explanation}>
                                {this.renderTextDiv(activeTeam?.answer, this.getTextSizeStyle(activeTeam?.answer, 50, 90))}
                            </div>)
                        }
                    }
                    break;

                case GAME_STATES.FINAL_ROUND_ANSWERING:
                case GAME_STATES.FINAL_ROUND_SELECT:
                case GAME_STATES.FINAL_ROUND_CATEGORY_SELECT:
                case GAME_STATES.FINAL_ROUND_SUMMARY:
                    if (activeTeam && activeTeamIndex !== team.id) {
                        showDefaultView = true;
                        content.push(this.renderTextDiv(`${activeTeam.name} are in the final round!`, styles.title));
                    }
                    break;
                case GAME_STATES.DETAILED_DISPLAY:
                case GAME_STATES.ROUND_SUMMARY:
                case GAME_STATES.MENU:
                case GAME_STATES.END_GAME:
                
                    break;
                case GAME_STATES.LOADING:
                    showDefaultView = true;
                    content.push(this.renderTextDiv("There's nothing for you to do, keep an eye on the main screen!"));
                    break;
                default:
                    showDefaultView = true;
                    content.push(this.renderTextDiv("There's nothing for you to do, keep an eye on the main screen!"));
                    break;
            }
        } else {
            showDefaultView = true;
            content.push(this.renderTextDiv(`Waiting for host to connect...`, styles.title));
        }

        return (
            <div className={`${styles.defaultView} ${showDefaultView && styles.show}`}>
                {content}
            </div>
        )
    }

    renderSelectingTeamsView(viewState, player, players, teams) {
        const correctState = this.state.roomState?.pointlessData?.gameState === GAME_STATES.MENU && this.state.hostConnected;
        const noTeam = player.pointlessData?.teamIndex === -1;
        let showTeamSelectView = correctState;
        const ignoreStates = [
            GAME_STATES.PRE_LOAD,
            GAME_STATES.LOADING,
            GAME_STATES.FINAL_ROUND,
            GAME_STATES.FINAL_ANSWER_IDLE,
            GAME_STATES.FINAL_ROUND_ANSWERING,
            GAME_STATES.FINAL_ROUND_CATEGORY_SELECT,
            GAME_STATES.FINAL_ROUND_INTRO, 
            GAME_STATES.FINAL_ROUND_REVEAL,
            GAME_STATES.FINAL_ROUND_SELECT,
            GAME_STATES.FINAL_ROUND_SUMMARY,
            GAME_STATES.GAME_OVER,
            GAME_STATES.GAME_OVER_IDLE,
            GAME_STATES.END_GAME,
        ]
        if (!ignoreStates.includes(this.state.roomState?.pointlessData?.gameState) && noTeam) showTeamSelectView = true;

        return (
            <div className={`${styles.teamSelect} ${showTeamSelectView && styles.show}`}>
                {this.renderTextDiv(<>WHICH TEAM WOULD<br />YOU LIKE TO BE ON?</>, styles.instruction)}
                <div className={styles.teamButtons}>
                    {
                        teams.map((team, index) => {
                            const teamFull = team.memberIds.length >= 2;
                            const teamPlayers = players.filter(x => team.memberIds.includes(x.id));
                            return <div className={`${styles.teamSelectButtonWrapper} ${index === player.pointlessData?.teamIndex ? styles.selected : teamFull ? styles.disabled : ""}`}
                                key={"team-" + index}
                                style={{ "--team-colour": team.colour }}
                            >
                                <img src={ClientPodium} />
                                <img src={ClientPodiumGlow} className={`${styles.glow} ${index === player.pointlessData?.teamIndex && styles.show}` } />
                                <button
                                    className={`${styles.teamSelectButton} `}
                                    onClick={(e) => this.clickSelectTeam(e, index)}
                                >
                                    {
                                        teamPlayers.length === 0 ?
                                            this.renderTextDiv(team.name, styles.fade)
                                            :
                                            teamPlayers.map(x => this.renderTextDiv(x.name))
                                    }
                                </button>
                            </div>
                        })
                    }
                </div>

                {correctState && this.renderMainButton("START GAME", false, false, this.signalStartGame)}
            </div>
        )
    }

    renderPreRound(viewState, player, players, team) {
        const showRoundSummary = this.state.roomState?.pointlessData?.gameState === GAME_STATES.DETAILED_DISPLAY && this.state.hostConnected;

        return (
            <div className={`${styles.teamSelect} ${showRoundSummary && styles.show}`}>
                {this.renderMainButton("START ROUND", false, false, () => this.state.room?.send(MESSAGES.TO_SERVER.END_PRE_ROUND, {}))}
            </div>
        )
    }

    renderAnsweringView(viewState, player, players, team) {
        const pointlessData = this.state.roomState?.pointlessData;
        const showAnsweringView =
            pointlessData?.gameState === GAME_STATES.ANSWERING &&
            pointlessData.activeTeamIndex === team?.id &&
            this.state.hostConnected &&
            !team.submitted;

        const explanation = pointlessData?.questionExplanation;
        const teamAnswers = team?.answers;
        const members = players.filter(x => team?.memberIds.includes(x.id));

        return (
            <div className={`${styles.answeringSection} ${showAnsweringView && styles.show}`}>
                {explanation && explanation.length > 0 && (
                    <div className={styles.explanation}>
                        {this.renderTextDiv(
                            explanation,
                            this.getTextSizeStyle(explanation, 50, 90)
                        )}
                    </div>
                )}

                {team?.memberIds.length > 1 && (
                    <div className={styles.teamAnswersSection}>
                        {this.renderTextDiv(`Your teams answers`, `${styles.title}`)}
                        {this.renderTextDiv(`(click one to vote)`)}
                        <div className={styles.list}>
                            {teamAnswers?.map((x, i) => {
                                if (!x || x.length === 0) return null;
                                return (
                                    <div
                                        key={i}
                                        className={styles.teamAnswer}
                                        onClick={(e) => this.voteAnswer(e, x, i)}
                                    >
                                        <div className={styles.votes}>
                                            {members.map((y, ind) => {
                                                if (y.pointlessData.voteAnswerIndex === i) {
                                                    return (
                                                        <img
                                                            key={y.id}
                                                            className={`${styles.player} ${ind === 0 ? styles.left : styles.right}`}
                                                            src={y.avatar}
                                                            alt={y.id}
                                                        />
                                                    );
                                                }
                                                return null;
                                            })}
                                        </div>
                                        {this.renderTextDiv(x)}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                <form
                    className={styles.inputSection}
                    onSubmit={(e) => {
                        this.submitAnswer(e);
                    }}
                >
                    <input
                        type="text"
                        maxLength={50}
                        onChange={this.updateAnswer}
                        value={this.state.answer}
                        placeholder="Enter an answer..."
                        className={styles.answerInput}
                    />
                    <button type="submit" className={styles.submitButton}>
                        <img src={sendIcon} alt="Send" />
                    </button>
                </form>
            </div>
        );
    }


    renderConfirmAnswerView(viewState, player, players, team) {
        const showConfirmAnswerView = this.state.showConfirmAnswerView && this.state.hostConnected;
        const answer = this.state.confirmAnswer;
        return (
            <div className={`${styles.confirmModal} ${showConfirmAnswerView && styles.show}`}>
                <div className={styles.screenOverlayBG}></div>
                <div className={styles.modal}>
                    {this.renderTextDiv("Confirm Answer", styles.title)}
                    <p>{this.renderTextDiv(`Do you want to submit:`)}</p>
                    <p>{this.renderTextDiv(`"${answer?.trim()}"`, styles.large)}</p>
                    <div className={styles.buttons}>
                        {this.renderMainButton("ACCEPT", false, false, this.acceptAnswer)}
                        {this.renderMainButton("DECLINE", false, false, this.declineAnswer)}
                        {/*<button onClick={this.acceptAnswer} className={`${styles.mainButton} ${styles.alt}`}>{this.renderTextDiv("ACCEPT")}</button>*/}
                        {/*<button onClick={this.declineAnswer} className={`${styles.mainButton}`}>{this.renderTextDiv("DECLINE")}</button>*/}
                    </div>
                </div>
            </div>
        )
    }

    renderSuggestAnswerView(viewState, player, players, team) {
        const showSuggestAnswerView = this.state.showSuggestAnswerView && this.state.hostConnected;
        const answer = this.state.suggestAnswer;
        const teamMate = players.find(x => x.pointlessData.teamIndex == player.pointlessData.teamIndex && x.id !== player.id);

        return (
            <div className={`${styles.confirmModal} ${showSuggestAnswerView && styles.show}`}>
                <div className={styles.screenOverlayBG}></div>
                <div className={styles.modal}>
                    {this.renderTextDiv("Confirm Answer", styles.title)}
                    <p>{this.renderTextDiv(`${teamMate?.name} has suggested submitting:`)}</p>
                    <p>{this.renderTextDiv(`"${answer?.trim()}"`)}</p>
                    <div className={styles.buttons}>
                        {this.renderMainButton("ACCEPT", false, false, this.acceptAnswer)}
                        {this.renderMainButton("DECLINE", false, false, this.declineAnswer)}
                        {/*<button onClick={this.acceptAnswer} className={`${styles.mainButton} ${styles.alt}`}>{this.renderTextDiv("ACCEPT")}</button>*/}
                        {/*<button onClick={this.declineAnswer} className={`${styles.mainButton}`}>{this.renderTextDiv("DECLINE")}</button>*/}
                    </div>
                </div>
            </div>
        )
    }

    renderRoundSummaryView(viewState, player, players, team) {
        const showRoundSummary = this.state.roomState?.pointlessData?.gameState === GAME_STATES.ROUND_SUMMARY && this.state.hostConnected && this.state.roomState?.pointlessData?.roundSummaryCompleted;

        return (
            <div className={`${styles.teamSelect} ${showRoundSummary && styles.show}`}>
                {this.renderMainButton("MOVE TO NEXT ROUND", false, false, () => this.state.room?.send(MESSAGES.TO_SERVER.VOTE_MOVE_ON, {}))}
            </div>
        )
    }

    renderFinalRoundSummaryView(viewState, player, players, team) {
        const showRoundSummary = this.state.roomState?.pointlessData?.gameState === GAME_STATES.FINAL_ROUND_SUMMARY && this.state.hostConnected;

        return (
            <div className={`${styles.teamSelect} ${showRoundSummary && styles.show}`}>
                {this.renderMainButton("CONTINUE", false, false, () => this.state.room?.send(MESSAGES.TO_SERVER.VOTE_MOVE_ON, {}))}
            </div>
        )
    }

    renderFinalCategorySelect(viewState, player, players, team) {
        const pointlessData = this.state.roomState?.pointlessData;
        const activeTeamIndex = pointlessData?.activeTeamIndex;
        const showCategorySelect = pointlessData?.gameState === GAME_STATES.FINAL_ROUND_CATEGORY_SELECT && activeTeamIndex === team.id && this.state.hostConnected;

        const finalCategories = pointlessData?.finalCategories;

        return (
            <div className={`${styles.categorySelect} ${showCategorySelect && styles.show}`}>
                <div className={styles.buttons}>
                    {this.renderMainButton(finalCategories[0], false, false, () => this.state.room?.send(MESSAGES.TO_SERVER.SELECT_FINAL_CATEGORY, { categoryIndex: 0 }))}
                    {this.renderMainButton(finalCategories[1], false, false, () => this.state.room?.send(MESSAGES.TO_SERVER.SELECT_FINAL_CATEGORY, { categoryIndex: 1 }))}
                </div>
            </div>
        )
    }


    renderFinalAnswerView(viewState, player, players, team) {
        const pointlessData = this.state.roomState?.pointlessData;
        const showAnsweringView = pointlessData?.gameState === GAME_STATES.FINAL_ROUND_ANSWERING && pointlessData?.activeTeamIndex === team?.id && this.state.hostConnected;
        const teamAnswers = team?.finalAnswers;

        return (
            <div className={`${styles.answeringSection} ${styles.final} ${showAnsweringView && styles.show}`}>
                {this.renderMainButton("SHOW HINTS", false, false, () => this.setState({ showHints: true }))}
                <br />
                <div className={styles.teamAnswersSection}>
                    {this.renderTextDiv("Your teams answers:", `${styles.title}`)}
                    <div className={styles.list}>
                        {
                            teamAnswers?.map((x) => {
                                if (!x || x.length === 0) return;
                                return <div className={`${styles.teamAnswer} ${styles.noHover}`}>{this.renderTextDiv(x)}</div>
                            })
                        }
                    </div>
                </div>
                {/*<div className={styles.inputSection}>*/}
                    <form
                        className={styles.inputSection}
                        onSubmit={(e) => {
                            this.submitAnswer(e);
                        }}
                    >
                        <input
                            type="text"
                            maxLength={50}
                            onChange={this.updateAnswer}
                            value={this.state.answer}
                            placeholder="Enter an answer..."
                            className={styles.answerInput}
                        />
                        <button type="submit" className={styles.submitButton}>
                            <img src={sendIcon} />
                        </button>
                    </form>
                {/*</div>*/}
            </div>
        )
    }

    renderFinalHints() {
        const showHints = this.state.showHints && this.state.hostConnected;
        const pointlessData = this.state.roomState?.pointlessData;
        const questions = pointlessData?.questions;

        return (
            <div className={`${styles.confirmModal} ${showHints && styles.show}`}>
                <div className={`${styles.screenOverlayBG} ${styles.darker}`}></div>
                <div className={styles.hints}>
                    {this.renderMainButton("HIDE HINTS", false, false, () => this.setState({showHints: false}))}
                    {
                        questions.map(x => {
                            if (x.hint) {
                                return <div className={styles.hint}>{this.renderTextDiv(x.hint, styles.small)}</div>
                            }
                        })
                    }
                </div>
            </div>
        )
    }

    renderFinalSelect(viewState, player, players, team) {
        const pointlessData = this.state.roomState?.pointlessData;
        const showFinalSelect = pointlessData?.gameState === GAME_STATES.FINAL_ROUND_SELECT && pointlessData.activeTeamIndex === team?.id && this.state.hostConnected && !team.submitted;
        const teamAnswers = team?.finalAnswers;
        const chancesLeft = pointlessData?.finalAnswersLeft;
        const members = players?.filter(x => team?.memberIds.includes(x.id));

        return (
            <div className={`${styles.answeringSection} ${showFinalSelect && styles.show} ${styles.final}`}>
                <div className={styles.teamAnswersSection}>
                    {this.renderTextDiv("Select an answer you think is Pointless", `${styles.title}`)}
                    {this.renderTextDiv(`You have ${chancesLeft} chances left`, `${styles.subTitle}`)}
                    {this.renderTextDiv(`(click one to vote)`)}
                    <div className={styles.list}>
                        {
                            teamAnswers?.map((x, i) => {
                                if (!x || x.length === 0) return;
                                return <div className={`${styles.teamAnswer}`} onClick={(e) => this.voteAnswer(e, x, i)}>
                                    <div className={styles.votes}>
                                        {
                                            members.map((y, ind) => {
                                                if (y.pointlessData.voteAnswerIndex === i) {
                                                    return <img className={`${styles.player} ${ind === 0 ? styles.left : styles.right}`} src={y.avatar} alt={y.id} />
                                                }
                                            })
                                        }
                                    </div>
                                    {this.renderTextDiv(x)}
                                </div>
                            })
                        }
                    </div>

                </div>
            </div>
        )
    }

    renderGameOver(viewState, player, players, team) {
        const pointlessData = this.state.roomState?.pointlessData;
        const showGameOver = pointlessData?.gameState === GAME_STATES.END_GAME && this.state.hostConnected;

        return <div className={`${styles.gameOver} ${showGameOver && styles.show}`}>
            {this.renderMainButton("PLAY AGAIN", false, false, this.signalNewGame)}
            {this.renderMainButton("LOBBY", false, false, this.signalChangeGame)}
        </div>
    }

    renderDebugButton(viewState, player, players, team) {
        const pointlessData = this.state.roomState?.pointlessData;
        const showDebug = pointlessData?.gameState === GAME_STATES.ANSWERING && pointlessData?.answerTesting

        return <div className={`${styles.debug} ${showDebug && styles.show}`}>
            {this.renderMainButton("NEXT QUESTION", false, false, () => this.state.room?.send(MESSAGES.TO_SERVER.DEBUG_NEXT_QUESTION, {}))}
        </div>
    }

    render() {
        if (this.state.redirectURL) {
            return (
                <React.Fragment>
                    <div className={styles.clientWrapper}>
                        <div id="clientContainer" className={styles.clientContainer}>
                            <Loading loadingText={"Sending you to the lobby!"} />
                        </div>
                    </div>

                    <div style={{ opacity: 0 }}>
                        {
                            this.state.redirect ?
                                <Route path="/" render={() => (window.location = this.state.redirectURL)} />
                                :
                                null
                        }
                    </div>
                </React.Fragment>
            )
        }

        const pointlessData = this.state.roomState?.pointlessData;
        if (!pointlessData) {
            return (
                <Loading loadingText={"Connecting you to the game..."} noBg={true} hideLoader={false} />
            )
        }

        const player = this.state.roomState?.players?.get(this.state.myId);
        //const viewState = this.getCurrentViewState(player);
        const viewState = "";
        const teams = pointlessData?.teams;
        const team = teams && player ? teams[player.pointlessData.teamIndex] : null;
        const players = this.state.roomState?.players ? Array.from(this.state.roomState.players.values()) : null;
        const waitingForHost = !this.state.hostConnected;

        const noTeam = player.pointlessData?.teamIndex === -1;

        return (
            <div className={styles.clientWrapper}>
                {
                    this.state.room && pointlessData ?
                        <div id="clientContainer" className={`${styles.clientContainer}`}>
                            <ClientMenuIcon
                                room={this.state.room}
                                gameState={this.state.gameState}
                                mutedMusic={this.state.roomState?.pointlessData?.mutedMusic}
                                mutedSfx={this.state.roomState?.pointlessData?.mutedSfx}
                            />
                            {
                                this.state.isPaused &&
                                <div className={styles.pauseContainer}>
                                    <div className={styles.pauseText}>Paused</div>
                                </div>
                            }
                            {this.renderPlayerSection(viewState, player, team)}
                            {this.renderDefaultView(viewState, player, players, team, teams)}
                            {this.renderSelectingTeamsView(viewState, player, players, teams)}
                            {
                                !noTeam && <>
                                    {this.renderPreRound(viewState, player, players, team)}
                                    {this.renderAnsweringView(viewState, player, players, team)}
                                    {this.renderConfirmAnswerView(viewState, player, players, team)}
                                    {this.renderSuggestAnswerView(viewState, player, players, team)}
                                    {this.renderRoundSummaryView(viewState, player, players, team)}
                                    {this.renderFinalRoundSummaryView(viewState, player, players, team)}
                                    {this.renderFinalCategorySelect(viewState, player, players, team)}
                                    {this.renderFinalAnswerView(viewState, player, players, team)}
                                    {this.renderFinalHints()}
                                    {this.renderFinalSelect(viewState, player, players, team)}
                                    {this.renderGameOver(viewState, player, players, team)}
                                    {this.renderDebugButton(viewState, player, players, team)}
                                </>
                            }
                        </div>
                        :
                        <Loading loadingText={"Connecting you to the game..."} noBg={true} hideLoader={false} />
                }
            </div>
        );
    }
}
